<template>
  <div>
    <!-- <div
      class="filter_products"
      @click="toggleSearchFilter"
      v-if="isMobileCheck == 'true' || isTabletCheck == 'true'"
    >
      <div class="statistic_filter">
        <span>FILTER</span>
        <i class="md-icon md-icon-font md-theme-default">filter_alt</i>
      </div>
    </div> -->
    <div class="card-wrap scroll col-sm-12 p-0">
      <div class=" col-sm-4 wrapper_card" :key="post.id" v-for="post in posts">
        <div class=" card col-sm-12 p-0">
          <Item :post="post" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Item from "./statisticItem";
import Follow from "./Follow";
import { isMobile, isTablet } from "mobile-device-detect";

export default {
  name: "statisticsList",
  props: ["posts"],
  components: {
    Follow,
    Item
  },
  data() {
    return {
      isMobileCheck: isMobile ? "true" : "false",
      isTabletCheck: isTablet ? "true" : "false",
      backgroundImage: `url(${require("@/assets/images/banner_default.jpg")})`
    };
  },

  methods: {
    toggleSearchFilter() {
      this.$emit("handleToggleFilter");
      this.$store.dispatch("ToggleHeader");
    },
    slugify(text, ampersand = "and") {
      const a = "àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧ";
      const b = "aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzh";
      const p = new RegExp(a.split("").join("|"), "g");
      return text
        .toString()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, `-${ampersand}-`)
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+|-+$/g, "");
    },

    profileHandler(name, id) {
      if (name !== "" && id !== "") {
        localStorage.setItem("profile_user_name", name);
        localStorage.setItem("profile_user_id", id);
        this.$router.push({ path: "/profile/" + this.slugify(name) });
      } else {
        alert("something went wrong");
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return;
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    ...mapState({
      profileIconUrl: state => state.statistic.profileIconUrl,
      CoverUrl: state => state.statistic.CoverUrl,
      retrievedTokenDetail: state => state.user.retrievedTokenDetail
    }),
    getFirstChar() {
      return name => name.charAt(0);
    },
    getSlug() {
      return name => this.slugify(name);
    }
  },
  watch: {
    tag: "initItems",
    posts: {
      // the callback will be called immediately after the start of the observation

      immediate: true,
      handler(val, oldVal) {
        console.log(val, oldVal);
      },
      deep: true
    }
  },
  created() {}
};
</script>
<style scoped>
.statistic_filter {
  border: 1px solid #bbbbbb;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filter_products {
  display: flex;
  justify-content: center;
  /* padding: 10px; */
  /* border: 1px solid red; */
  /* margin: 5px; */
  padding-bottom: 10px;
  padding-right: 10px;
}
.email-to {
  color: rgb(115, 129, 152) !important;
}
.wrapper_card {
  float: left;
  padding: 0px 5px;
}
.listing-on {
  width: 775px;
  max-width: 100%;
}
.card {
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;

  box-shadow: 0 2px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);

  margin-bottom: 7px;
  display: inline-block;
  height: 230px;
}
.card-cover {
  display: block;
  max-width: 100%;
  object-fit: cover;
  height: 90px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.ProfileCard-content {
  margin: 13px 15px;
  position: relative;
}
.ProfileCard-avatarLink {
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
  margin: -45px 2px 0 -3px;
  padding: 3px;
  position: relative;
  vertical-align: bottom;
  z-index: 1;
}
.ProfileCard-avatarLink img {
  border-radius: 50%;
  display: block;
  height: 70px;
  width: 70px;
  object-fit: cover;
  margin: 0 auto;
}
.ProfileCard-userFields {
  color: #14171a;
  margin-top: 15px;
  width: 100%;
}
.name-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  line-height: 1.4;
}
.verified {
  display: inline-flex;
  margin-left: 2px;
}
.name-wrap .verified i {
  color: #1a73e8;
  font-size: 18px;
  position: relative;
  top: 4px;
}
.profile-bg {
  border-radius: 50%;
  display: flex;
  height: 70px;
  width: 70px;
  -o-object-fit: contain;
  object-fit: contain;
  margin: 0 auto;
  background-color: #ff5722;
  justify-content: center;
  align-items: center;
}
.profile-bg span {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
}
.ProfileName {
  cursor: pointer;
  margin-top: -2px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  align-items: center;
  position: relative;
  display: inline-flex;
}
/* .ProfileName:after{
   content: "...";
  position: absolute;
  right: 0;
  top: 0;
  background-color: white;
  padding: 0 5px;
} */
.Type {
  font-size: 11px;
  color: #888;
  font-weight: 500;
}
.ProfileCard-actions {
  display: inline-block;
  height: 31px;
  margin: 0 0 -4px 0;
  position: absolute;
  right: 0;
  vertical-align: bottom;
}
.ProfileCard-actions .md-button {
  height: 29px;
  min-width: 75px;
  font-size: 12px;
  padding: 5px 3px;
  border-radius: 100px;
  color: #ff5722 !important;
  border: 1px solid rgba(33, 59, 100, 0.7);
  box-sizing: border-box;
  box-shadow: none;
}
.bottom-action {
  margin-top: 0.8em;
}
.bottom-action .item {
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 50%;
  background: #fff;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  background-color: rgba(33, 58, 99, 0.11);
}
.bottom-action .item a {
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
}
.bottom-action .item i {
  margin: 0 auto;
  font-size: 19px;
  color: rgb(115, 129, 152);
}
.card-wrap {
  padding-bottom: 30px;
}

@media only screen and (max-width: 768px) {
  .card {
    height: 240px;
  }
}
@media only screen and (max-width: 600px) {
  .card {
    height: 195px;
    border-radius: 10px;
  }

  .wrapper_card {
    float: left;
    padding: 0px 5px;

    display: block;
    width: 50%;
  }
}

@media only screen and (max-width: 300px) {
  .card {
    height: 195px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/statistics/statisticsList.vue